module.exports = __webpack_public_path__ + "static/media/kathy-huynh-CK.74864f25.jpg";